export default "__VITE_ASSET__DDnzyDTj__"